import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { IGalleryApiResponse, IGalleryData } from '../../types/api/galleryApi';
import { getGalleryDataService } from '../../api/galleryApi';
import { IGalleryState } from '../../types/features/gallerySlice';




export const getGalleryData = createAsyncThunk<IGalleryApiResponse>(
    'gallery/getGalleryData',
    async () => {
        const response = await getGalleryDataService();
        return response.data; // Assumes response has a 'data' property
    }
);

const gallerySlice = createSlice({
    name: 'gallery',
    initialState: {
        galleryLoader: false,
        gallery: [],
        room_gallery: [],
        status: false,
        msg: ''
    } as IGalleryState, // Type the initialState with AuthState
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(getGalleryData.pending, (state) => {
                state.galleryLoader = true;
            })
            .addCase(getGalleryData.fulfilled, (state, action: PayloadAction<IGalleryApiResponse>) => {
                let data = action.payload.data;
                state.gallery = data;
                if (data && data.length) {
                    state.room_gallery = data.filter((d: IGalleryData) => d.is_room_gallery === true);
                }
                state.msg = action.payload.message;
                state.status = true;
                state.galleryLoader = false;
            })
            .addCase(getGalleryData.rejected, (state, action) => {
                state.galleryLoader = false;
                state.status = false;
                state.msg = action.error.message;
            })

    }
});

export default gallerySlice.reducer;
